import { render, staticRenderFns } from "./PathologyDetail.vue?vue&type=template&id=05663d75&scoped=true"
var script = {}
import style0 from "./PathologyDetail.vue?vue&type=style&index=0&id=05663d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05663d75",
  null
  
)

export default component.exports